import React from "react";

import ClipLoader from "react-spinners/ClipLoader";

import FaceBookSdk from "components/Leads/SharedComponents/FaceBookSdk";

import { FACEBOOK_CAPI_SCOPE } from "../../DestinationCreation.constants";
import OrDivider from "../OrDivider";

/** "Continue with Facebook CAPI" login ("or" the manual pixel / token fields). */
const FacebookCapiForm = ({
    language,
    appObject,
    facebook,
    isLoading,
    setIsButtonLoader,
}) => (
    <div>
        <div className="position-relative overflow-hidden z-1 mb-3">
            {isLoading && (
                <div className="circle-loader max-height-45">
                    <ClipLoader color={"#000"} size={17} />
                </div>
            )}
            <FaceBookSdk
                appId={appObject.app_id && appObject.app_id.toString()}
                updatedData={facebook.handleLogin}
                scope={FACEBOOK_CAPI_SCOPE}
                text="Continue with Facebook CAPI"
                extras={facebook.beExtra}
                version={appObject.version && appObject.version.toString()}
                setModalLoading={setIsButtonLoader}
            />
        </div>
        <OrDivider language={language} />
    </div>
);

export default FacebookCapiForm;
